import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import { intervalModeIds } from '../../../../shared/configs/selectionData/intervalModes';
import { useFieldController } from '../../../../../../helpers/formManager';
import styles from './index.module.scss';

const Checkboxes = ({ withExpertId, control }) => {
  const disabled = withExpertId !== intervalModeIds.universal;

  return (
    <div className={styles.checkboxes}>
      <Checkbox disabled={disabled} name="withExpert" control={control}>
        С экспертом
      </Checkbox>
      <Checkbox name="byProxy" control={control}>
        По доверенности
      </Checkbox>
    </div>
  );
};

export default Checkboxes;

function Checkbox({ name, disabled = false, control, children }) {
  const { field } = useFieldController({ name, control });

  const handleChange = (e) => {
    field.onChange(e.target.checked);
  };

  return (
    <AntCheckbox
      checked={field.value}
      onChange={handleChange}
      disabled={disabled}
    >
      {children}
    </AntCheckbox>
  );
}
